import React, { useMemo } from 'react';
import '../../assets/styles/Home.css';
import { useLanguage } from '../../assets/js/LanguageContext';
import CircularTestimonials from '../common/CircularTestimonials';
import SectionEyebrow from '../common/SectionEyebrow';
import '../../assets/styles/SectionBand.css';
import ernestImage from '../../assets/images/book-characters/alma-serrat.jpg';
import questImage from '../../assets/images/book-characters/gael-montes.jpg';
import enduranceImage from '../../assets/images/book-characters/vera-solano.jpg';
import henryImage from '../../assets/images/book-characters/damian-roldan.jpg';

const CHARACTERS = [
  { key: 'ernest', name: 'Alma Serrat', image: ernestImage, focus: '18%' },
  { key: 'quest', name: 'Gael Montes', image: questImage },
  { key: 'endurance', name: 'Vera Solano', image: enduranceImage },
  { key: 'henry', name: 'Damián Roldán', image: henryImage, focus: '18%' },
];

const HomeBookCharacters = () => {
  const { t, language } = useLanguage();

  const testimonials = useMemo(
    () =>
      CHARACTERS.map((character) => ({
        name: character.name,
        designation: t(`home_characters_${character.key}_role`),
        quote: t(`home_characters_${character.key}_desc`),
        src: character.image,
        focus: character.focus,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [language]
  );

  return (
    <section id="personajes-libro" className="section-band">
      <div className="section-band__inner">
        <div className="section-band__head">
          <SectionEyebrow>{t('home_characters_eyebrow')}</SectionEyebrow>
        </div>

        <div className="characters__stage">
          <CircularTestimonials
            testimonials={testimonials}
            autoplay
            labels={{ prev: t('characters_prev'), next: t('characters_next') }}
          />
        </div>
      </div>
    </section>
  );
};

export default HomeBookCharacters;
